<template>
<div>
	<router-view></router-view>
</div>
</template>

<script>
import router from '../router'
import EventBus from '../eventBus';

export default {
	name: 'app',
	components: {},
	data() {
		return {}
	},
	watch: {
		'$route' (to, from) {
			if(to.name === "Builder"){
				console.log(to);
				EventBus.$emit("fadeInBuilder");
			}
		}
	},

}
</script>
<style scoped lang="scss">
.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-leave-active {
    transition: all 0.3s cubic-bezier(1.0, 0.5, 0.8, 2.0);
}
/* .slide-fade-leave-active below version 2.1.8 */
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// App.vue?fc561fac